module.exports = __webpack_public_path__ + "img/selected_company_radio_button.aab2fef4.svg";